module.exports = __webpack_public_path__ + "assets/media/desktop-illustration.b196b228.png";